import { CashflowDto } from '../cashflow.dto';

export class CashFlowReportDto {
  cashflow: CashflowDto;
  income: number;
  expense: number;
  total: number;
}
